<div (click)="onClick($event)" class="wrapper" [class.hidden]="enableStateChange === false">
  <div [title]="title" class="map-control-btn" [ngClass]="{ 'mobile-btn': isMobile }">
    <i #icon [ngClass]="buttonClassname"></i>
  </div>
</div>
